var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchNew = function SvgSearchNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BAB9B9",
    fillRule: "evenodd",
    d: "M12.595 12.595a.75.75 0 0 1 1.06 0l3.375 3.375a.75.75 0 1 1-1.06 1.06l-3.375-3.375a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BAB9B9",
    fillRule: "evenodd",
    d: "M.75 8.25a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0m7.5-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12",
    clipRule: "evenodd"
  })));
};
export default SvgSearchNew;